import React, { ReactElement, FunctionComponent, useEffect } from 'react'
import BasicText, { BasicTextProps } from '../BasicText'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../../utils/Deprecation'

export type HeadlineProps = Pick<
    BasicTextProps,
    | 'children'
    | 'color'
    | 'textAlign'
    | 'webHeadlineType'
    | 'numberOfLines'
    | 'bold'
    | 'paddingTop'
    | 'paddingBottom'
    | 'paddingLeft'
    | 'paddingRight'
    | 'paddingX'
    | 'paddingY'
> &
    Partial<Pick<BasicTextProps, 'fontSize'>> &
    TestID

const HeadlineFont: FunctionComponent<HeadlineProps> = ({
    children,
    color,
    bold = true,
    textAlign,
    webHeadlineType,
    numberOfLines,
    fontSize = 'FS30',
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingX,
    paddingY,
    testID,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('HeadlineFont')
    }, [])
    return (
        <BasicText
            color={color}
            fontSize={fontSize}
            lineHeight="LH34"
            numberOfLines={numberOfLines}
            textAlign={textAlign}
            bold={bold}
            webHeadlineType={webHeadlineType}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            paddingX={paddingX}
            paddingY={paddingY}
            testID={testID}
        >
            {children}
        </BasicText>
    )
}

export default HeadlineFont
